import { getConfig } from "config";
import { generateOtpHeader } from "services/lockerAuth";
import { requestLockerJson, requestLockerVoid } from "services/lockerClient";

type ReservationsFilter = {
  active?: boolean;
  code?: string;
};

export const fetchLocker = async (): Promise<Locker> => {
  const { apiKey, lockerId } = getConfig();
  return requestLockerJson<Locker>(`lockers/${lockerId}/`, {
    headers: {
      "x-otp-code": generateOtpHeader(apiKey),
    },
    errorMessage: (response) => `Error fetching locker: ${response.statusText}`,
  });
};

export const fetchReservations = async (
  filter?: ReservationsFilter
): Promise<PaginatedResponse<Reservation>> => {
  const { lockerId } = getConfig();
  return requestLockerJson<PaginatedResponse<Reservation>>("reservations/", {
    params: {
      locker_id: lockerId,
      active: filter?.active !== undefined ? filter.active.toString() : undefined,
      code: filter?.code,
    },
  });
};

export const createReservation = async (data: Reservation): Promise<Reservation> => {
  const { lockerId } = getConfig();
  return requestLockerJson<Reservation>("reservations/", {
    method: "POST",
    body: { ...data, locker_id: lockerId },
  });
};

export const updateReservation = async (data: Reservation): Promise<Reservation> => {
  const { lockerId } = getConfig();
  return requestLockerJson<Reservation>(`reservations/${data.id}/`, {
    method: "PATCH",
    body: { ...data, locker_id: lockerId },
  });
};

export const cancelReservation = async (id: string): Promise<void> => {
  await requestLockerVoid(`reservations/${id}/cancel`, {
    method: "POST",
  });
};

export const fetchRecipients = async (): Promise<Recipient[]> => {
  return requestLockerJson<Recipient[]>("recipients/");
};

export const createBulkReservation = async (data: BulkReservation): Promise<BulkReservation> => {
  const { lockerId } = getConfig();
  return requestLockerJson<BulkReservation>("reservationsBulk", {
    method: "POST",
    body: { ...data, locker_id: lockerId },
  });
};

export type { ReservationsFilter };
